import React, { FC } from 'react';

interface Props {
    title: any;
    onClick: Function;
    theme?: String;
    style?: React.CSSProperties;
    disabled?: boolean;
}

const Button: FC<Props> = ({ onClick, title, theme = 'simple', style = {}, disabled }) => {
    const disabledStyle: React.CSSProperties = {
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? 'not-allowed' : '',
    };
    return (
        <div
            className={`font-xs rounded px-2 py-1 flex cursor-pointer items-center justify-center ${
                theme == 'simple' ? 'text-purpleFont' : 'text-white bg-purpleFont'
            } border border-purpleFont text-center font-bold`}
            onClick={() => {
                if (disabled) return;
                onClick();
            }}
            style={{ ...disabledStyle, ...style }}
        >
            <span className="flex justify-center items-center">{title}</span>
        </div>
    );
};

export default Button;
